// extracted by mini-css-extract-plugin
export default {"optionLabel":"v0IX5m"};